import { DropdownMenu } from "@au-schein-de/au-ui-library";
import type React from "react";

export interface UserProfileMenuItemProps {
	id: string;
	testId: string;
	icon?: React.ReactNode;
	label: string;
	badge?: string;
	pillBadge?: string;
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	marginTop?: string;
	hasBackground?: boolean;
	textColor?: string;
	disableHover?: boolean;
	hoverColor?: string;
}

export function UserProfileMenuItem({
	id,
	testId,
	icon,
	label,
	badge,
	pillBadge,
	onClick,
	marginTop = "p-0",
	hasBackground = true,
	textColor = "text-gray-700",
	disableHover = false,
	hoverColor = "group-hover:text-ansay-main",
}: UserProfileMenuItemProps) {
	const backgroundClass = hasBackground ? "bg-white" : "";

	const handleSelect = () => {
		onClick({
			currentTarget: { id },
		} as React.MouseEvent<HTMLButtonElement>);
	};

	return (
		<DropdownMenu.Item asChild className={marginTop} onSelect={handleSelect}>
			<button
				id={id}
				data-testid={testId}
				type="button"
				className={`group w-full justify-start ${backgroundClass} text-body-bold h-auto p-2 ${textColor} flex items-center gap-3 rounded-xl cursor-pointer transition-colors`}
			>
				{icon ? (
					hasBackground ? (
						<div className="flex items-center justify-center w-10 h-10 bg-ansay-background flex-shrink-0 rounded-lg [&_svg]:size-5">
							{icon}
						</div>
					) : (
						icon
					)
				) : null}
				<div className="flex min-w-0 flex-1 items-center justify-between gap-2">
					<div className="flex min-w-0 items-center gap-1">
						<span
							className={`truncate ${disableHover ? "" : `${hoverColor} transition-colors`}`}
						>
							{label}
						</span>
						{badge ? (
							<span className="shrink-0 text-body-medium text-gray-500">
								{badge}
							</span>
						) : null}
					</div>
					{pillBadge ? (
						<span
							className="shrink-0 rounded px-2 py-1 mr-2 text-caption-emphasis uppercase bg-ansay-light text-gray-900"
							data-testid={`${testId}-pill-badge`}
						>
							{pillBadge}
						</span>
					) : null}
				</div>
			</button>
		</DropdownMenu.Item>
	);
}
